export default "__VITE_ASSET__DPp10z7d__"